export default __webpack_public_path__ + "static/media/home-artist2.e5250a47.jpg";